import { CartGiftType } from '@rc-d2c/context-manager';
import { useFormattedPrice } from '@rc-d2c/shared-behavior';
import { RcCard, RcSkuOption, RcTag } from '@rc-d2c/shared-ui';
import classnames from 'classnames/bind';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './CartGiftCard.module.scss';

const cx = classnames.bind(styles);

const CartGiftCard = ({ name, imgUrl, price }: CartGiftType) => {
  const { t } = useTranslation();
  const { formatPrice } = useFormattedPrice();

  return (
    <RcCard testId="cart-gift-card" withoutShadow customClasses={cx('cart-gift-card')}>
      <header className={cx('cart-gift-card__header')}>
        <h3 className={cx('cart-gift-card__header__title')}>{name}</h3>
      </header>
      <div className={cx('cart-gift-card__content')}>
        <img src={imgUrl} alt={name} className={cx('cart-gift-card__image')} />
        <div className={cx('cart-gift-card__details')}>
          <RcSkuOption stock={1} quantity={1} label={t('cart.cartProductCard.inStock')} />

          <div className={cx('cart-gift-card__details__price')}>
            <p className={cx('cart-gift-card__details__price--disabled')}>{formatPrice(price)}</p>
            <RcTag customClasses={cx('cart-gift-card__details__price__offered')} color="success" rounded variant="solid">
              {t('cart.cartProductCard.offered')}
            </RcTag>
          </div>
        </div>
      </div>
    </RcCard>
  );
};

export default CartGiftCard;
